import React from "react";
import { Control, FieldValues } from "react-hook-form";

import { PriorPolicyExpirationDate } from "@covertree/new-business-graphql";
import { FormSelectField } from "@covertree/ui";

export const expirationOptions = [
  { label: "1-7 days ago", value: PriorPolicyExpirationDate.Between1_7 },
  { label: "8-30 days ago", value: PriorPolicyExpirationDate.Between8_30 },
  { label: "31-90 days ago", value: PriorPolicyExpirationDate.Between31_90 },
  {
    label: "More than 90 days ago",
    value: PriorPolicyExpirationDate.MoreThan90,
  },
  {
    label: "My home has never been insured",
    value: PriorPolicyExpirationDate.NeverBeenInsured,
  },
];

export const expirationValues = expirationOptions.map((option) => option.value);

interface Props<TValues extends FieldValues> {
  control: Control<TValues>;
  name?: string;
  label?: string;
  placeholder?: string;
}

export function InsuranceExpirationSelect<TValues extends FieldValues>({
  control,
  name = "priorInsuranceExpirationTimeline",
  label = "When did your insurance expire?",
  placeholder = "Select...",
}: Props<TValues>) {
  return (
    <FormSelectField
      control={control}
      id="expiration-date"
      dataTestId="expiration-date-field"
      options={expirationOptions}
      name={name}
      label={label}
      placeholder={placeholder}
    />
  );
}
